import React, { useCallback, useState, useEffect } from 'react';

import { Button, IconArrow } from './styles';

const TopButton = () => {
  const [show, setShow] = useState(false);
  const [ticking, setTicking] = useState(false);
  const [lastPos, setLastPos] = useState(0);

  const scrollHandler = useCallback(() => {
    setLastPos(window.scrollY);
    if (!ticking) {
      window.requestAnimationFrame(() => {
        setShow(lastPos > window.innerHeight * 0.3 ? true : false);
        setTicking(false);
      });
      setTicking(true);
    }
  }, [lastPos, ticking]);

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler);
    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, [scrollHandler]);

  const clickHandler = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  return show ? (
    <Button onClick={clickHandler}>
      <IconArrow />
    </Button>
  ) : (
    <></>
  );
};

export default TopButton;
